require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./child-abuse-and-family-violence-summit.json") })
        }
      }, "path---child-abuse-and-family-violence-summit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---child-abuse-and-family-violence-summit!./.cache/json/child-abuse-and-family-violence-summit.json
// module id = 850
// module chunks = 231608221292675